import React from 'react';
import logo from '../assets/gbl-logo.png';

export default function LoadingPage({ message }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
      <div className="text-center animate-fade-in">
        <img src={logo} alt="GBL" className="h-10 mx-auto mb-8 opacity-80" />
        <div className="relative mx-auto w-10 h-10">
          <div className="w-10 h-10 rounded-full border-3 border-[#E8F0FE]" />
          <div className="absolute inset-0 w-10 h-10 rounded-full border-3 border-transparent border-t-[#1A73E8] animate-spin" style={{ borderWidth: 3 }} />
        </div>
        {message && (
          <p className="mt-4 text-sm text-[#5F6368] font-medium">{message}</p>
        )}
      </div>
    </div>
  );
}
